/**
 * i18n 类型定义
 *
 * 为整个应用提供统一的国际化类型系统
 */

/**
 * 支持的语言代码
 */
export type Locale = "zh-CN" | "en";

/**
 * 默认语言
 */
export const DEFAULT_LOCALE: Locale = "en";

/**
 * 支持的所有语言列表
 */
export const SUPPORTED_LOCALES: Locale[] = ["zh-CN", "en"];

/**
 * 语言显示名称
 */
export const LOCALE_NAMES: Record<Locale, string> = {
  "zh-CN": "简体中文",
  en: "English",
};

/**
 * 翻译键类型
 * 使用点号分隔的路径来组织翻译键
 * 例如：'common.ok', 'model.image.seedream.label'
 */
export type TranslationKey = string;

/**
 * 翻译值类型
 * 可以是字符串或接受参数的函数
 */
export type TranslationValue =
  | string
  | ((params?: Record<string, unknown>) => string);

/**
 * 翻译字典类型
 * 支持嵌套结构
 */
export type TranslationDict = {
  [key: string]: TranslationValue | TranslationDict;
};

/**
 * 语言包类型
 * 每个语言对应一个完整的翻译字典
 */
export type LanguagePack = Record<Locale, TranslationDict>;
